(function(){
    'use strict';

    angular.module('elogbooks.common.webhooks', []);
})();